import React from "react";
import { ErrorMessage, useField } from "formik";
import "../cmnStyle.css";

export const TextFieldIcon = ({
  label,
  isRequired,
  autoComplete,
  readOnly,
  ...props
}) => {
  const [field, meta] = useField(props);

  return (
    <div className="mb-2 inputIconClass">
      <label htmlFor={field.name} className="label-inpt">
        {label} {isRequired && <span className="astrk">*</span>}
      </label>
      <div className="input-icons">
        <i className={props.icon}></i>
        <input
          className={`form-control shadow-none login-input ${
            readOnly ? "read-only-input" : ""
          }`}
          {...field}
          {...props}
          autoComplete={autoComplete}
          readOnly={readOnly}
        />

        {props.eyeicon && (
          <i className={props.eyeicon} onClick={props.iconClick}></i>
        )}
      </div>
      {/* {!meta.touched || meta.error?(
      <ErrorMessage component="div" name={field.name} className="error" />
        ):null} */}
      <ErrorMessage component="div" name={field.name} className="errStyle" />
    </div>
  );
};
